import { Injectable, signal } from '@angular/core';
import { Prescription } from '../models/prescription.model';

@Injectable({
  providedIn: 'root'
})
export class PrescriptionService {
  private prescriptions = signal<Prescription[]>([]);

  constructor() {
    // Initialize with mock data
    this.prescriptions.set([
      {
        id: '1',
        patientId: '1',
        patientName: 'Alice Johnson',
        doctorId: '1',
        doctorName: 'Dr. Sarah Williams',
        date: new Date(),
        medications: [
          {
            name: 'Aspirin',
            dosage: '81mg',
            frequency: 'Once daily',
            duration: '30 days',
            quantity: 30,
            instructions: 'Take with food',
            refills: 2
          }
        ],
        status: 'Active',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ]);
  }

  getPrescriptions() {
    return this.prescriptions.asReadonly();
  }

  getPrescriptionById(id: string): Prescription | undefined {
    return this.prescriptions().find(p => p.id === id);
  }

  getPrescriptionsByPatient(patientId: string): Prescription[] {
    return this.prescriptions().filter(p => p.patientId === patientId);
  }

  addPrescription(prescription: Omit<Prescription, 'id' | 'createdAt' | 'updatedAt'>): Prescription {
    const newPrescription: Prescription = {
      ...prescription,
      id: Date.now().toString(),
      createdAt: new Date(),
      updatedAt: new Date()
    };
    this.prescriptions.update(prescriptions => [...prescriptions, newPrescription]);
    return newPrescription;
  }

  updatePrescription(id: string, updates: Partial<Prescription>): void {
    this.prescriptions.update(prescriptions =>
      prescriptions.map(p =>
        p.id === id ? { ...p, ...updates, updatedAt: new Date() } : p
      )
    );
  }

  deletePrescription(id: string): void {
    this.prescriptions.update(prescriptions => prescriptions.filter(p => p.id !== id));
  }
}

